export const colorPlayerCount = (nbPlayers: number) => {
	if (nbPlayers < 10) {
		return "red";
	}
	else if (10 <= nbPlayers && nbPlayers < 20) {
		return "teal";
	}
	else if (nbPlayers === 20) {
		return "green";
	}
	else if (20 < nbPlayers && nbPlayers <= 30) {
		return "teal";
	}
	return "red";
};